import { FC, useEffect, useState } from "react";
import {
  useAppDispatch as useDispatch,
  useAppSelector as useSelector,
} from "../../../store";
import {
  hideTransparentPreloaderAction,
  showTransparentPreloaderAction,
} from "../../../store/application/slice";
import { getDashboardData } from "../../../store/dashboard/thunks";
import { getCandidateData } from "../../../store/superadmin/thunks";
import ViewProfile from "../../Client/Candidates/PopupModal/ViewProfile";
import CandidateProfiles from "./CandidateProfiles";
import CentreEnquiries from "./CentreEnquiries";
import FlaggedCandidates from "./FlaggedCandidates";
import UrgentVacanciesPanel from "./UrgentVacanciesPanel";
import WeeklyForecast from "./WeeklyForecast";

const Dashboard: FC = () => {
  const dispatch = useDispatch();

  const dashboardData = useSelector((state) => state.dashboard.dashboradData);

  const [showProfileModal, setShowProfileModal] = useState<boolean>(false);

  // Pagination states
  const [flaggedEmpPage, setFlaggedEmpPage] = useState<number>(1);
  const [flaggedEmpPerPage, setFlaggedEmpPerPage] = useState<number>(3);

  // Handle pagination link click
  const handleFlaggedEmpPageChange = (url: string | null) => {
    if (url) {
      const page = new URL(url).searchParams.get("page");
      setFlaggedEmpPage(Number(page));
    }
  };

  const handleProfile = async (id: string) => {
    dispatch(showTransparentPreloaderAction());
    await dispatch(
      getCandidateData({
        candidate_id: String(id),
        // centre_id: storage.get(STORAGE_KEYS.SELECTED_CENTRE_ID),
      })
    );
    dispatch(hideTransparentPreloaderAction());
    setShowProfileModal(!false);
  };

  const onClickClose = () => {
    setShowProfileModal(false);
  };

  const fetchDashboardData = async () => {
    dispatch(showTransparentPreloaderAction());
    await dispatch(
      getDashboardData({
        page: flaggedEmpPage,
        per_page: flaggedEmpPerPage,
      })
    );
    dispatch(hideTransparentPreloaderAction());
  };

  useEffect(() => {
    fetchDashboardData();
  }, [flaggedEmpPage, flaggedEmpPerPage]);

  return (
    <>
      <div className="d-flex flex-column gap-30">
        <div className="d-flex flex-column flex-lg-row gap-30">
          <div className="d-flex flex-column gap-30 w-100">
            {/* Urgent Vacancies */}
            <UrgentVacanciesPanel
              urgent_vacancies={dashboardData?.urgent_vacancies || 0}
            />
            {/* New Candidate Profiles */}
            <CandidateProfiles
              stage_1_review={dashboardData?.stage_1_review || 0}
              stage_2_review={dashboardData?.stage_2_review || 0}
              stage_3_review={dashboardData?.stage_3_review || 0}
              edit_request_count={dashboardData?.edit_request_count || 0}
              compliance_alerts_count={dashboardData?.compliance_alerts_count || 0}
              compliance_alerts_review_count={dashboardData?.compliance_alerts_review_count || 0}
            />
           
            {/* Weekly Forecast */}
            {/* {dashboardData?.weekly_forecast && (
              <WeeklyForecast
                weekly_forecast={dashboardData?.weekly_forecast}
              />
            )} */}
          </div>
          <div className="d-flex flex-column gap-30 w-100">

             {/* Flagged Candidates */}
            {dashboardData?.flagged_users && (
              <FlaggedCandidates
                flagged_users={dashboardData?.flagged_users}
                handleProfile={handleProfile}
                page={flaggedEmpPage}
                handlePageChange={handleFlaggedEmpPageChange}
                setPerPage={setFlaggedEmpPerPage}
                setPage={setFlaggedEmpPage}
              />
            )}

            
            {/* New Centre Enquiries */}
            {(dashboardData?.enquiry_count ?? 0) > 0 && (
              <CentreEnquiries enquiry_count={dashboardData!.enquiry_count} />
            )}
            {/* Centre Site Inspection */}
            {/* High Demand Locations */}
            {/* <DemandLocations /> */}
            {/* <CentreTasks /> */}
            {dashboardData?.weekly_forecast && (
              <WeeklyForecast
                weekly_forecast={dashboardData?.weekly_forecast}
              />
            )}
          </div>
        </div>
      </div>
      <ViewProfile
        showProfileModal={showProfileModal}
        onClickClose={onClickClose}
      />
    </>
  );
};

export default Dashboard;
